import React from "react";

export default function IntroSection({
  title,
  subtitle,
  icon,
  iconImg,
  iconSize = "h-16",
  padding = "py-10"
}) {
  return (
    <section className={`text-center ${padding} px-4 sm:px-6 max-w-4xl mx-auto`}>
      {iconImg ? (
        <img src={iconImg} alt="icon" className={`mx-auto ${iconSize} mb-2`} />
      ) : (
        <div className="text-pink-400 text-xl sm:text-2xl mb-2">{icon}</div>
      )}
      <h2 className="text-3xl sm:text-4xl elegant-font mb-4 leading-tight break-words">{title}</h2>
      <div className="text-gray-600 text-sm sm:text-base leading-relaxed max-w-3xl mx-auto">{subtitle}</div>
    </section>
  );
}
